import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { EventPreviewProps } from '@Components/TicketedEvents/EventPreview';

interface EventPreviewStore {
  previewData: EventPreviewProps | null;
  setPreviewData: (data: EventPreviewProps) => void;
  clearPreviewData: () => void;
}

export const useEventPreviewStore = create<EventPreviewStore>()(
  persist(
    (set) => ({
      previewData: null,
      setPreviewData: (data) => set({ previewData: data }),
      clearPreviewData: () => set({ previewData: null }),
    }),
    {
      name: 'event-preview',
    },
  ),
);
